import React from "react"
import {
  Box, Flex, Text,
} from "@chakra-ui/react"
import Button from "components/Buttons/Button"
import Link from "components/elements/Link"
import OptInMsgIcon from "components/elements/OptInMsgIcon"
import { WHATSAPP_OPT_IN_PROCESS_ARTICLE_LINK } from "utilities/externalLinks"

type Props = {
  isDefault: boolean
  onSetAsDefault: () => Promise<void> | void
}

const OptInInfoBox = ({ isDefault, onSetAsDefault }: Props) => (
  <Flex
    flexDirection="column"
    borderRadius="md"
    borderWidth={1}
    p={4}
    bgColor={isDefault ? "whatsapp.25" : "yellow.100"}
    w="full"
    maxW="750px"
    gap={2}
  >
    <Flex justifyContent="space-between" alignItems="center">
      <Text fontWeight="semibold">WhatsApp Opt-In Message</Text>
      {isDefault ? (
        <Flex
          alignItems="center"
          gap={1.5}
          color="whatsapp.500"
          fontSize="sm"
          fontWeight="medium"
          textTransform="uppercase"
          letterSpacing="wider"
        >
          <Text>Default</Text>
          <OptInMsgIcon boxSize={4} />
        </Flex>
      ) : (
        <Button
          variant="outline"
          size="xs"
          borderRadius="full"
          px={4}
          onClick={onSetAsDefault}
        >
          Set as Default
        </Button>
      )}
    </Flex>
    <Text>
      Guests who haven&apos;t opted in will receive this opt-in message
      first. If they approve within 48 hours, your message is sent
      automatically.
    </Text>
    <Box>
      Learn more:{" "}
      <Link href={WHATSAPP_OPT_IN_PROCESS_ARTICLE_LINK} target="_blank">
        WhatsApp Opt-In Process
      </Link>
    </Box>
  </Flex>
)

export default OptInInfoBox
